import { post, getJson } from './'

export const startCD = (params) => {
  return post(`${config.cpp}handler/v2/countDown/start`, params)
}

export const endCD = (webcastId) => {
  return post(`${config.cpp}handler/v2/countDown/stop/${webcastId}`)
}

export const refreshCD = (webcastId) => {
  return post(`${config.cpp}handler/v2/countDown/refresh/${webcastId}`)
}

export const getCD = (webcastId) => {
  return getJson(`${config.cpp}handler/v2/countDown/info/${webcastId}`)
}

/**
 * 重新开始倒计时
 * @param {*} webcastId 
 * @returns 
 */
export const resumeCD = (webcastId) => {
  return post(`${config.cpp}handler/v2/countDown/resume/${webcastId}`)
}
/**
 * 暂停倒计时
 * @param {*} webcastId 
 * @returns 
 */
export const suspendCD = (webcastId) => {
  return post(`${config.cpp}handler/v2/countDown/suspend/${webcastId}`)
}